import { render, staticRenderFns } from "./AppReleasesIcon.vue?vue&type=template&id=79a84760"
import script from "./AppReleasesIcon.vue?vue&type=script&lang=js"
export * from "./AppReleasesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports